"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getForegroundColor = getForegroundColor;
exports.italic = exports.underline = exports.bold = exports.textThemes = void 0;

var _styledComponents = require("styled-components");

var _baseColorThemes = _interopRequireDefault(require("./baseColorThemes"));

var _helperFunctions = require("../helperFunctions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var textThemes = [].concat(_toConsumableArray(_baseColorThemes.default), ['default', 'overDark', 'disabled' // yeah, i know this doesnt make a lot of sense...
]);
exports.textThemes = textThemes;
var bold = (0, _styledComponents.css)(["font-weight:", ";"], function (props) {
  return props.theme.primaryHeavy;
});
exports.bold = bold;
var underline = (0, _styledComponents.css)(["text-decoration:underline;"]);
exports.underline = underline;
var italic = (0, _styledComponents.css)(["font-style:italic;"]);
exports.italic = italic;

function getForegroundColor(props, override) {
  var color = override || (0, _helperFunctions.removeGhost)(props.colorTheme);
  var themeKey = "c_foreground_".concat(color);
  return props.theme[themeKey];
}